import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Backdrop from '@mui/material/Backdrop';
import PropTypes from 'prop-types';
import useTheme from '../../hooks/useTheme';

const Loader = ({isBackdrop = false, onClick  ,loaderType , size = 32, progressValue = 0 , borderRadius = '4px' , height = '1px'}) => {
    const {color, zIndex} = useTheme();
    if(loaderType === 'line'){
        return (
            <LinearProgress
                color="secondary"
                sx={{
                    height: '8px',
                    borderRadius: '4px',
                    '& .MuiLinearProgress-bar': {
                        backgroundImage: `linear-gradient(to right, rgba(80, 13, 118, 0) 29%, ${color.icon.brand} 101%)`, // Gradient from blue to green
                    },
                }}
        />);
    }else if(isBackdrop && loaderType === 'circle') {
        return (<Backdrop
            sx={{ color: color.background.primary, zIndex: zIndex.popOver }}
            open={isBackdrop}
            onClick={() => onClick(false)}
        >
          <Gradient color = {color.icon.brand} size = {size} />  
        </Backdrop>);
    }else if (loaderType === 'dividerProgressLine'){
        return(
            <LinearProgress
                sx={{
                    '&.MuiLinearProgress-colorPrimary:not(.MuiLinearProgress-buffer)':{ 
                        backgroundColor: color.button.secondary
                    },
                    '& .MuiLinearProgress-colorPrimary': {
                        backgroundColor: color.background.brand,
                    },
                    '& .MuiLinearProgress-barColorPrimary': {
                        backgroundColor: color.background.brand,
                    },
                    borderRadius: {borderRadius},
                    height: {height},
                }}
                variant="determinate"
                value = {progressValue}
            />
        )
    }
    else {
        return (<Gradient color = {color.icon.brand} size = {size} /> );
    } 
}

Loader.propTypes = {
    size : PropTypes.number,
    loaderType : PropTypes.oneOf(['circle', 'line']),
    isBackdrop : PropTypes.bool,
    onClick : PropTypes.func,
    progressValue : PropTypes.number,
    borderRadius : PropTypes.string,
    height : PropTypes.string
}



const Gradient = ({color, size}) => {
    return(<React.Fragment>
        <svg width={0} height={0}>
            <defs>
            <linearGradient id="spinner_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor={"rgba(80, 13, 118, 0)"}/>
                <stop offset="100%" stopColor={color} />
            </linearGradient>
            </defs>
        </svg>
        <CircularProgress size ={size}  sx={{ 'svg circle': { stroke: 'url(#spinner_gradient)' }}} />
    </React.Fragment>)
}

Gradient.propTypes = {
    color : PropTypes.string, 
    size : PropTypes.number
}



Loader.defaultProps = {
    isBackdropRequired : false,
    loaderType :'circle',
    onClick : () => {},
    size : 32,
}
export default Loader
